import request from '../../utils/request'

// 管理员登录
export const login = (data) => {
  return request({
    url: '/api/admin/login',
    method: 'post',
    data
  })
}

// 获取用户列表信息
export const getAdminList = (data) => {
  return request({
    url: `/api/admin/list?pageNum=${data.pageNum}&pageSize=${data.pageSize}&username=${data.username}&nickname=${data.nickname}&role=${data.role}&status=${data.status}`,
    method: 'get'
  })
}

// 创建管理员
export const addAdmin = (data) => {
  return request({
    url: '/api/admin/create',
    method: 'post',
    data
  })
}

// 重置管理员密码
export const editAdminPassword = (data) => {
  return request({
    url: '/api/admin/resetPassword',
    method: 'post',
    data
  })
}

// 删除管理员
export const delAdmin = (adminId) => {
  return request({
    url: `/api/admin/delete/${adminId}`,
    method: 'post',
  })
}
 